import {useCurrentState} from "../globalState";
import AlertDialog from "./AlertDialog";
import React from "react";
import spawnConfirmation from "../confirmationDialog";

function ConfirmationDialogs() {
    let [dialogs, setDialogs] = useCurrentState("confirmationDialogs");

    spawnConfirmation.setDialogs = setDialogs;
    spawnConfirmation.getDialogs = () => dialogs;

    return <div>
        {dialogs.map((spec, index) => <AlertDialog key={index} spec={spec}/>)}
    </div>
}


export default ConfirmationDialogs;